module.exports = __webpack_public_path__ + "media/images/icons/arrow_right-378250765ac044f6fdd4de5e7b518a65.svg";